import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import MbTableRow from './EnhancedTableRow';
import clsx from 'clsx';
// import TableFooter from '@material-ui/core/TableFooter';
import TableCell from '@material-ui/core/TableCell';
import Skeleton from '@material-ui/lab/Skeleton';
import CurrentStatus from 'components/atoms/CurrentStatus';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

const useStyles = makeStyles((theme) => ({
  fullscreenBody: {
    height: 600,
  },
}));

/**
 * 테이블 body 컴포넌트
 * @param {Object} props
 */
const EnhancedTableBody = (props) => {
  const classes = useStyles();
  const {
    headCells,
    list = [],
    hasTotal,
    totalList = null,
    selected = [],
    hasCheckbox,
    pointer,
    handleClick = (f) => f,
    error = false,
    page = 0,
    customized,
    expandTable,
    childColumnSet,
    handleRowClick = (f) => f,
    wantRowData,
    loading,
    reLoading,
    hasModal,
    onMouseEnter, // eslint-disable-next-line
    firstFetching,
    getScreenMode,
  } = props;

  const columnCnt = Array.isArray(headCells)
    ? headCells.length
    : headCells.size === undefined
    ? 0
    : headCells.size;

  const isSelected = (key) => {
    return selected.indexOf(key) !== -1;
  };
  /**
   * 리스트생성 함수
   * @returns {[]}
   */
  const makeRowItems = () => {
    const result = [];
    if (list !== null && list.length !== 0) {
      // eslint-disable-next-line
      list.map((row, index) => {
        const isItemSelected = isSelected(row.name);

        result.push(
          <MbTableRow
            classes={classes}
            key={index}
            index={index}
            row={row}
            headCells={headCells}
            isSelected={isSelected(index)}
            hasCheckbox={hasCheckbox}
            wantRowData={wantRowData}
            pointer={pointer}
            handleClick={handleClick}
            handleRowClick={handleRowClick}
            customized={customized}
            expandTable={expandTable}
            hasModal={hasModal}
            childColumnSet={childColumnSet}
            selected={isItemSelected}
          />
        );
      });
    }
    return result;
  };

  return (
    <>
      {hasTotal && !error && (
        <TableBody
          className={clsx(
            getScreenMode === 'full' ? classes.fullscreenBody : ''
          )}
        >
          {list === null ||
          list.length === 0 ||
          totalList === null ||
          totalList.length === 0 ? (
            <TableRow tabIndex={-1}>
              {reLoading || loading ? (
                <TableCell
                  className={classes.totalCell}
                  colSpan={columnCnt + 1}
                >
                  <Skeleton />
                </TableCell>
              ) : null}
            </TableRow>
          ) : (
            <MbTableRow
              classes={{
                totalCell: classes.totalCell,
                cell: classes.cell,
              }}
              row={totalList[0]}
              headCells={headCells}
              customized={customized}
              hasCheckbox={hasCheckbox}
              isTotal={true}
            />
          )}
        </TableBody>
      )}
      <TableBody
        className={classes.tablebody}
        onMouseEnter={!reLoading && loading ? (f) => f : onMouseEnter}
      >
        {list === null || list.length === 0 ? (
          <TableRow
            style={{ height: 49 * 5 }}
            className={classes.beforeLoadBody}
          >
            {page <= 1 && (loading || error || list.length === 0) && (
              <TableCell colSpan={columnCnt + 1}>
                {reLoading || loading ? (
                  <>
                    <Skeleton />
                    <Skeleton width="60%" />
                    <Skeleton />
                    <Skeleton width="60%" />
                    <Skeleton />
                    <Skeleton width="60%" />
                  </>
                ) : error ? (
                  <CurrentStatus type="error" />
                ) : list.length === 0 ? (
                  <CurrentStatus type="noData" />
                ) : null}
              </TableCell>
            )}
          </TableRow>
        ) : (
          <>
            {reLoading || loading ? (
              <>
                <TableRow
                  style={{ height: 49 * 5 }}
                  className={classes.beforeLoadBody}
                >
                  <TableCell colSpan={columnCnt + 1}>
                    <Skeleton />
                    <Skeleton width="60%" />
                    <Skeleton />
                    <Skeleton width="60%" />
                    <Skeleton />
                    <Skeleton width="60%" />
                  </TableCell>
                </TableRow>
              </>
            ) : list !== null && list.length !== 0 ? (
              makeRowItems()
            ) : null}
          </>
        )}
      </TableBody>
    </>
  );
};

// const equalComparison = (prevProps, nextProps) => {
//   let result;
//   // if (prevProps.list !== nextProps.list || nextProps.hasTotal === true) {
//   //   result = false;
//   // } else {
//   //   if (nextProps.firstFetching == true) {
//   //     result = false;
//   //   } else {
//   //     result = true;
//   //   }
//   // }
//
//   //console.log('prevProps', prevProps);
//   //console.log('nextProps', nextProps);
//   if (
//     JSON.stringify(prevProps.list) !== JSON.stringify(nextProps.list) ||
//     JSON.stringify(prevProps.totalList) !== JSON.stringify(nextProps.totalList)
//   ) {
//     result = false;
//     //console.log('1 result', result);
//   } else {
//     if (nextProps.firstFetching === true) {
//       result = false;
//       //console.log('2 result', result);
//     } else {
//       result = true;
//       //console.log('3 result', result);
//     }
//   }
//
//   return result;
// };

EnhancedTableBody.propTypes = {
  handleClick: PropTypes.func, //  디스플레이 구분
};

export default React.memo(withRouter(EnhancedTableBody));
